import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.125 1.541a2.25 2.25 0 0 1 2.25 2.25v12.417a2.25 2.25 0 0 1-2.25 2.25h-8.25a2.25 2.25 0 0 1-2.25-2.25V8.121c0-.596.237-1.169.658-1.59L8.61 2.2c.422-.422.995-.66 1.592-.66zm-3.791 4.458a2.25 2.25 0 0 1-2.25 2.252H5.125v7.957c0 .414.336.75.75.75h8.25a.75.75 0 0 0 .75-.75V3.791a.75.75 0 0 0-.75-.75h-3.793zm-4.15.752h1.9A.75.75 0 0 0 8.834 6l-.002-1.9z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.999 9.042a.75.75 0 0 1 .75.75v3.191l.596-.595.056-.052a.75.75 0 0 1 1.004 1.113l-1.875 1.873-.057.052q-.016.011-.034.021a.7.7 0 0 1-.256.12q-.037.01-.074.017l-.017.003a1 1 0 0 1-.093.007l-.019-.002q-.037-.002-.074-.008-.032-.002-.063-.009-.027-.006-.053-.014-.044-.012-.086-.029l-.022-.011a1 1 0 0 1-.093-.051l-.037-.028q-.04-.03-.075-.06l-.007-.008-1.875-1.873-.052-.057a.75.75 0 0 1 1.056-1.056l.056.052.594.593V9.792a.75.75 0 0 1 .75-.75"
    }, null, -1)
  ]))]))
}
export default { render: render }